import React, { Component } from 'react';
import { provideHooks } from 'redial';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import reducer, * as cardActions from 'redux_store/modules/tenderCard';
import Card from 'components/TenderCard/index';
import { loadTenderCleanStatus } from 'redux_store/modules/adminZone';
import * as dictActions from 'redux_store/modules/dictionary/dictionary';
import { getVarible } from 'redux_store/modules/global';
import { Forbiden } from '../index';

@provideHooks({
  inject: ({ store }) => {
    store.inject({ tenderCard: reducer });
  },
  fetch: async ({ store: { dispatch, getState }, params, location, history }) => {
    const { tenderId } = params;
    const access = await dispatch(cardActions.checkAccess(tenderId)).catch(e => {
      history.push({
        pathname: `/${e.code}`,
      });
    });
    if (access) {
      const state = getState();
      const { zoneId } = state.login;
      const pathParts = location.pathname.split('/');
      const tab = pathParts[pathParts.length - 1];
      let promise = [];
      if (tab === 'history') {
        promise = [
          dispatch(cardActions.getHistory(tenderId)).catch(() => null),
          !dictActions.isLogTypeLoaded(state)
            ? dispatch(dictActions.loadLogType()).catch(() => null)
            : Promise.resolve(),
        ];
      }
      if (tab === 'participants') {
        promise = [
          dispatch(cardActions.loadParticipants(tenderId)).catch(() => null),
          !dictActions.isLogTypeLoaded(state)
            ? dispatch(dictActions.loadLogType()).catch(() => null)
            : Promise.resolve(),
        ];
      }
      if (tab === 'documents') {
        promise = [
          dispatch(cardActions.getDocuments(tenderId)).catch(() => null),
          !dictActions.isLogTypeLoaded(state)
            ? dispatch(dictActions.loadLogType()).catch(() => null)
            : Promise.resolve(),
        ];
      }
      if (tab === 'attributes') {
        promise = [
          dispatch(cardActions.getAttributes(tenderId)).catch(() => null),
          !dictActions.isLogTypeLoaded(state)
            ? dispatch(dictActions.loadLogType()).catch(() => null)
            : Promise.resolve(),
        ];
      }
      return Promise.all([
        dispatch(getVarible()).catch(() => null),
        dispatch(dictActions.loadUser(zoneId)).catch(() => null),
        dispatch(dictActions.loadZoneStatus(zoneId)).catch(() => null),
        dispatch(cardActions.getStatusOwner(tenderId)).catch(() => null),
        dispatch(cardActions.loadSubscribe(tenderId)).catch(() => null),
        dispatch(cardActions.userAccessGet(tenderId)).catch(() => null),
        dispatch(loadTenderCleanStatus(zoneId)).catch(() => null),
        dispatch(dictActions.loadDepartament(zoneId)).catch(() => null),
        !dictActions.isCurrencyLoaded(state)
          ? dispatch(dictActions.loadCurrency()).catch(() => null)
          : Promise.resolve(),
        !dictActions.isPlacingWayLoaded(state)
          ? dispatch(dictActions.loadPlacingWay()).catch(() => null)
          : Promise.resolve(),
        !dictActions.isPurchaseTypeLoaded(state)
          ? dispatch(dictActions.loadPurchaseType()).catch(() => null)
          : Promise.resolve(),
        !dictActions.isGridSortLoaded(state)
          ? dispatch(dictActions.loadGridSort()).catch(() => null)
          : Promise.resolve(),
        !dictActions.isRegionLoaded(state) ? dispatch(dictActions.loadRegion()).catch(() => null) : Promise.resolve(),
        !dictActions.isUserDependencyLoaded(state)
          ? dispatch(dictActions.loadUserDependency(zoneId)).catch(() => null)
          : Promise.resolve(),
        !dictActions.isMarkerLoaded(getState())
          ? await dispatch(dictActions.markerConfigGet()).catch(() => null)
          : Promise.resolve(),
        ...promise,
      ]);
    }
    return Promise.resolve();
  },
})
@connect(state => ({ access: state.tenderCard.access && !state.tenderCard.info.error }))
export default class TenderCard extends Component {
  static propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    match: PropTypes.objectOf(PropTypes.any).isRequired,
    access: PropTypes.bool.isRequired,
  };
  render() {
    if (!this.props.access) {
      return <Forbiden />;
    }
    const { tenderId } = this.props.match.params;
    return <Card tenderId={tenderId} />;
  }
}
